import {
  createEntityAdapter,
  createSlice,
  type EntityState,
  type PayloadAction,
} from "@reduxjs/toolkit";
import { updateBrandColor } from "./brands.thunk";

interface Brand {
  id: number;
  name: string;
  logo: string;
  displayName: string;
  position: number | null;
  color: string | null;
  marketIds: number[];
}

const brandsAdapter = createEntityAdapter<Brand, number>({
  // @ts-ignore
  selectId: (brand: Brand) => brand.id,
  sortComparer: (a: Brand, b: Brand) =>
    a.position && b.position ? a.position - b.position : 0,
});

const initialState = brandsAdapter.getInitialState();

export const brandsSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    setBrands: (state, action: PayloadAction<any[]>) => {
      brandsAdapter.setAll(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateBrandColor.fulfilled, (state, action) => {
      if (action.payload !== null) {
        brandsAdapter.updateOne(state, {
          id: action.payload.brandId,
          changes: {
            color: action.payload.color,
          },
        });
      }
    });
  },
});

export type BrandsAdapterType = EntityState<Brand, number>;

export const { setBrands } = brandsSlice.actions;

export default brandsSlice.reducer;
